
import { DriverDecisionSupportType } from "@enums/DriverDecisionSupportType";
import { IDriver } from "@interfaces/IDriver";
import { IVehicle } from "@interfaces/IVehicle";
import { IDriverTachoHours, TachoService } from "@services/tacho.service";
import * as angular from "angular";
import * as moment from "moment";
import "./driverTachoSummary.scss";

class DriverTachoSummaryController implements angular.IComponentController {

    driverTacho: IDriverTachoHours;
    tachoModeStatus: string;
    selectedVehicle: IVehicle;
    driver: IDriver;
    tachoTypes = DriverDecisionSupportType;
    displayTachoLimit = moment().add(-1, "day");
    isTachoOlderThanLimit = false;

    loading = false;

    dailyDrivePercentage: number;
    weeklyDriverPercentage: number;

    twoWeeklyDriveLimit: number;
    lastWeeksDrive: number;

    dailyDriveClass: string;
    weeklyDriveClass: string;

    errorValue: number;

    static $inject = ["tachoService"];

    constructor(
        private tachoService: TachoService
    ) {
    }

    $onChanges() {
        this.updateDisplay();
    }

    // ------------------------

    private updateDisplay() {

        this.twoWeeklyDriveLimit = 5400; //90 Hours
        this.lastWeeksDrive = 0;

        this.dailyDriveClass = "";
        this.weeklyDriveClass = "";

        this.errorValue = 60000;

        if (this.selectedVehicle) {
            console.warn("Use Driver over SelectedVehicle");
        }

        this.driver = this.driver || this.selectedVehicle?.Driver;

        if (!this.driver) {

            this.driverTacho = null;
            this.isTachoOlderThanLimit = false;

            this.dailyDrivePercentage = 0;
            this.weeklyDriverPercentage = 0;            

            return;
        }
     
        this.loadData();
    }

    private loadData() {
        this.loading = true;

        // Only get tacho for vehicles
        this.tachoService
            .getCurrentTachoForDriver(this.driver.Id)
            .then(driverTacho => {
                this.driverTacho = null;
                this.isTachoOlderThanLimit = false;

                if (!driverTacho || driverTacho.DriverId == 0) {
                    this.dailyDrivePercentage = 0;
                    this.weeklyDriverPercentage = 0;
                    return;
                }

                this.driverTacho = driverTacho;
                this.tachoService.processDriverTachoDisplay(driverTacho);

                this.tachoModeStatus = this.tachoService.getModeMessage(this.driverTacho.Mode);

                this.isTachoOlderThanLimit = this.driverTacho.DriverDecisionSupportType !== DriverDecisionSupportType.KLine && moment(this.driverTacho.EventTime) < this.displayTachoLimit;

                //Daily Drive Calculations
                if (this.driverTacho.MaximumDailyDrive && this.driverTacho.DailyDrive < this.errorValue) {
                    this.dailyDrivePercentage = Math.min(100,
                        (this.driverTacho.DailyDrive * 100) / (this.driverTacho.MaximumDailyDrive * 60));
                }
                else {
                    this.driverTacho.MaximumDailyDrive = null;
                }

                //Weekly Drive Calculations
                //Additional Calc to work out what available drive I have this week. Max 2 weeks is 90 hours.
                if (this.driverTacho.TwoWeekDrive < this.errorValue && this.driverTacho.WeeklyDrive < this.errorValue) {

                    this.lastWeeksDrive = (this.driverTacho.TwoWeekDrive - this.driverTacho.WeeklyDrive);

                    this.driverTacho.MaximumWeeklyDrive = (Math.min(3360, (this.twoWeeklyDriveLimit - this.lastWeeksDrive)) / 60);
                }

                //Now lets calculate what i've used of Max Weekly Drive
                if (this.driverTacho.MaximumWeeklyDrive && this.driverTacho.WeeklyDrive < this.errorValue && this.driverTacho.MaximumWeeklyDrive) {
                    this.weeklyDriverPercentage = Math.min(100, (this.driverTacho.WeeklyDrive * 100) / (this.driverTacho.MaximumWeeklyDrive * 60));
                }
                else {
                    this.driverTacho.MaximumWeeklyDrive = null;
                }

                this.dailyDriveClass = this.getPercentageClass(this.dailyDrivePercentage);
                this.weeklyDriveClass = this.getPercentageClass(this.weeklyDriverPercentage);

                if (!this.driverTacho.RemainingDrive) {
                    this.driverTacho.RemainingDrive = this.errorValue;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    }

    private getPercentageClass(percentage: number): string {
        if (percentage > 95) { return "red-color"; }
        else if (percentage > 80) { return "orange-color"; }

        return "";
    }
}

export class DriverTachoSummaryComponent implements angular.IComponentOptions {

    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
            selectedVehicle: "<",
            driver: "<",
        };

        this.controller = DriverTachoSummaryController;
        this.template = require("./driverTachoSummary.template.html");
    }
}
